import { jsx as _jsx } from "react/jsx-runtime";
import { CSIPopup } from '@clic/csi_widget_ssr';
import { memo } from 'react';
import vars from '@shared/config/vars';
import '@clic/csi_widget_ssr/dist/main.css';
const { API_ENV } = vars();
const CSIAgentReview = ({ isOpen, onFinish, onSubmit, surveyUID }) => _jsx(CSIPopup, { env: API_ENV, isOpen: isOpen, feedbackType: "stars", onFinish: onFinish, onSubmit: onSubmit, surveyUID: surveyUID, "data-sentry-element": "CSIPopup", "data-sentry-component": "CSIAgentReview", "data-sentry-source-file": "index.tsx" });
export default memo(CSIAgentReview);
